import { render, staticRenderFns } from "./ReceiveProduct.vue?vue&type=template&id=0b5aec64&"
import script from "./ReceiveProduct.vue?vue&type=script&lang=js&"
export * from "./ReceiveProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports